<div class="discard-mask">
    <div class="discard-dialog modal modal-welcome fade in" tabindex="-1" role="dialog" aria-labelledby="modal-title"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{message['headerHiThere']}}, {{username}}</h4>
                </div>
                <div class="modal-body">
                    <p style="font-size:larger">{{message['infoPart1']}}</p>
                    <ul>
                        <li style="font-size:larger">{{message['infoPart2']}}</li>
                        <li style="font-size:larger">{{message['infoPart3']}}</li>
                    </ul>
                    <p style="font-size:larger">{{message['infoPart4']}}</p>
                </div>
                <div class="modal-footer justify-content-end d-flex">
                    <button type="button" class="btn btn-default float-left"
                        (click)="close()">{{message['buttonClose']}}</button>
                    <button type="button" class="btn btn-default btn-primary"
                        (click)="ok()">{{message['buttonVisitHelp']}}</button>
                </div>
            </div>
        </div>
    </div>
</div>